import datasetExtractor from "@Dataset/datasetExtractor";

export const extractAndParse = (index: number, element: string) => (
    JSON.parse(datasetExtractor('gb--route-price', index, element))
)